module.exports = __webpack_public_path__ + "img/3_dots.ee7750d0.svg";